import './index.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, signInWithRedirect } from 'aws-amplify/auth';

const socialSignIn = async () => {
  try {
    await signInWithRedirect();
  } catch (ex) {
    console.log(JSON.stringify(ex));
  }
};

function Home(props) {
  const navigate = useNavigate();
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    getCurrentUser()
      .then(() => navigate('/transactions', { replace: true }))
      .catch(() => setCheckingAuth(false));
  }, [navigate]);

  if (checkingAuth) {
    return null;
  }

  return (
    <div>
      <p>
        This is the site to maintain Qboids for NetSuite integration
      </p>
      <button onClick={() => socialSignIn()}>Sign In</button>
    </div>
  );
}

export default Home;
